import { DataTableDataSearchDto } from '@asset-metrix/portal-gateway-client-js';

import { Filter } from '../states/filterTypes';

export function pickSelectionsFromFilter(
  filter?: Filter
): DataTableDataSearchDto['selection'] {
  return filter != null
    ? Object.entries(filter).reduce((acc, [key, value]) => {
        const selection = value?.selection;
        return {
          ...acc,
          ...(selection != null && { [key]: selection }),
        };
      }, {})
    : {};
}
